import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import getDetails from '../../../../../modules/getServiceStatusDetails';
import getServiceTypeLabels from '../../../../../modules/getServiceTypeLabels';
import { historyPropTypes } from '../../../../../types';
import {
  ServiceStatusContainer,
  ServiceStatusText,
  useServiceSummaryStyle,
} from './style';


const ServicesSummary = ({ history, services }) => {
  const classes = useServiceSummaryStyle();

  const onClickServiceDetailsButton = (serviceId) => {
    history.push(`/service/${serviceId}`);
  };

  return (
    <div className={classes.root}>
      <span>#</span>
      <span>Service</span>
      <span>Service Code</span>
      <span>Status</span>
      <span />

      {services.map(({
        _id: id, code, status, type,
      }, index) => {
        const details = getDetails(status);
        const { description } = getServiceTypeLabels(type);
        return (
          <Fragment key={id}>
            <span>{index + 1}</span>
            <span>{description}</span>
            <span>{code}</span>
            <span>
              <ServiceStatusContainer>
                <ServiceStatusText color={details.color}>{details.text}</ServiceStatusText>
              </ServiceStatusContainer>
            </span>
            <span>
              <Button
                onClick={() => onClickServiceDetailsButton(id)}
                variant="outlined"
                className={classes.detailsButton}
              >
                DETAILS
              </Button>
            </span>
          </Fragment>

        );
      })}
    </div>
  );
};

ServicesSummary.propTypes = {
  history : historyPropTypes.isRequired,
  services: PropTypes.arrayOf(PropTypes.shape({
    _id   : PropTypes.string,
    code  : PropTypes.string,
    status: PropTypes.string,
    type  : PropTypes.string,
  })),
};

ServicesSummary.defaultProps = {
  services: [],
};

export default ServicesSummary;
